import React, { Component } from 'react'
import { Doughnut } from 'react-chartjs-2'
import { inject, observer } from 'mobx-react'
import Countdown from 'react-countdown-now';
import { Card, Icon, List, Dropdown, message, Menu, Popconfirm } from 'antd'
import PropBets from './PropBets'
import { utils } from 'web3';
import { takeWager as takeContractWager } from '../../contract/WagersController'
import { takeWager as takeWagerApi } from '../../api-calls/wagers'
import { getSingleEventWagersForTeam } from '../../api-calls/wagers';
import { ethMultiplier, decimalsToShow } from '../../constants';
import { FaClipboard } from 'react-icons/fa';






//@inject("CategoriesStore", "eventStore") 
@observer(["AuthStore", "ViewStore", "eventStore", "AdminStore", "WagerStore", "BetSlipStore", "web3Store", "CustomRouter", "UserStore", "TeamStore", "CategoriesStore"])
class AvailableBets extends Component {

  constructor(props) {
    super(props);
    this.state = { display: "loading available bets" }
    this.takeBet = this.takeBet.bind(this);
  }


  takeBet(wager) {
    const {
      event_id,
      bytes32_id,
      start_time,
      duration } = this.props;
    const { BetSlipStore, web3Store, AuthStore, UserStore, WagerStore } = this.props;
    let token = AuthStore.userAuth.auth.accessToken;
    let amountToTake;
    let self = this;

    if (wager.odds > 99) {
      amountToTake = (wager.value) / (wager.odds / 100);
      // console.log("this one");
    } else {
      amountToTake = (wager.value) * (Math.floor(100 / wager.odds));

    }
    // console.log("floor " + Math.floor(100 / wager.odds));
    console.log("Amount to take " + amountToTake);

    //console.log("wager to take " + JSON.stringify(wager));
    //console.log("endTime" + start_time+duration);
    if (Date.now() > (start_time + duration) * 1000) {
      message.info("You can't take bets, the event has finished.");
    } else {
      // console.log("wager.odds " + wager.odds);
      // console.log("wager.value " + wager.value);
      //  console.log(wager.value / (wager.odds / 100));
      //  console.log("DIV -- " + Math.floor((wager.value * ethMultiplier) / Math.floor(wager.odds / 100)));
      takeContractWager(wager.bytes32Id, amountToTake).then( //SUBTRACT 1 from maker choice becasue contract (0= team one) and (1= team 2)

        function (result) {
          if (String(result).includes('User denied transaction signature')) {
            message.warning("Metamask transaction denied! No bet made.");
          } else {
            return takeWagerApi(token,
              UserStore.user._id,
              wager._id,
              wager.bytes32Id,
              amountToTake,
              web3Store.account,
              wager.eventId,
              wager.makerChoice).then(function () {
                WagerStore.queryEventWagers(wager.eventId);
                self.props.closeModal();
                return UserStore.updateUser(token);
              });
          }

        });
    }



  }




  componentDidMount() {
    
    getSingleEventWagersForTeam(this.props.event._id, this.props.teamChoice)
      .then((bets) => {
        if (bets.length > 0) {
          //let sortMethod = this.state.sortMethod;
          //bets.sort(sortMethod);
          console.log("team choice " + this.props.teamChoice);
          let selectedTeamName = this.props.team.name;
          let selectedTeamColor = this.props.team.colors[0];
          let selectedTeamLogo = this.props.team.logoUrl;

          this.setState({
            display: <div>
              AVAILABLE BETS
            {bets.map((bet) => {
                let potentialWin;

                if (bet.odds > 99) {
                  potentialWin = bet.value / (bet.odds / 100);
                } else {
                  potentialWin = bet.value * Math.floor(100 / bet.odds);

                }
                let popTitle = <div>
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <div><img src={selectedTeamLogo} width="75" /></div>
                    <div style={{ padding: '2px 0px 0px 6px' }}>You are betting for <strong style={{ textTransform: 'uppercase', letterSpacing: '1px', color: selectedTeamColor }}>
                    {selectedTeamName}</strong> to {this.props.win ? <span style={{fontSize:"16pt",color: 'rgb(58, 197, 90)'}}>WIN</span> :<span style={{fontSize:"16pt",color: "#f53c40"}}>LOSE</span>}</div>
                  </div>
                  <div>You are <strong style={{ textTransform: 'uppercase', letterSpacing: '1px', color: "#FFF" }}>betting {(potentialWin / ethMultiplier).toFixed(4)} ETH to win {(bet.value / ethMultiplier).toFixed(4)} ETH</strong></div>
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <div>
                      TOTAL POT = <span style={{ color: "#3ac55a" }}>{Number((potentialWin / ethMultiplier).toFixed(4)) + Number((bet.value / ethMultiplier).toFixed(4))} ETH</span>

                    </div>

                  </div>
                </div>;
                return <div style={{ marginBottom: "20px", padding: "15px", backgroundColor: "rgba(255,255,255,0.1)" }}>
                  Value: {(bet.value / ethMultiplier).toFixed(decimalsToShow)}
                  <br />
                  To Win: {(bet.value / ethMultiplier).toFixed(4)}
                  <br />
                  <Popconfirm placement={"right"} title={popTitle} onConfirm={this.takeBet.bind(this, bet)} okText="Confirm" cancelText="Cancel">
                    <button className="custom-btn-primary">Take Bet</button>
                  </Popconfirm>
                </div>
              })}</div>
          })
        } else {
          this.setState({
            display: <div style={{ textAlign: "center" }}>
              <p>NO BETS AVAILABLE TO TAKE</p>

              <FaClipboard style={{ fontSize: "30pt" }} />
              <br />
              {/* <p>TRY CREATING A NEW ONE</p> */}
              </div>
          })
        }

      })
  }

  render() {
    return (
      <div>
        <div style={{ backgroundColor: "rgba(0,0,0,0.5" }}>

          {this.state.display}
        </div>
      </div>
    )
  }
}
export default AvailableBets;


// WEBPACK FOOTER //
// ./src/components/layoutComponents/AvailableBets.js